import settings from 'Cloud/settings';
import { path, pathOr } from 'ramda';
import { getTrimmedText } from 'reactApp/utils/textHelpers';

/* Эти параметры урла прилетают с SRR и остаются неизменными до перезагрузки страницы. Если просто брать параметры из урла, то там они могут могут меняться без перезагрузки страницы */
export const getQueryParams: any = () => {
    return pathOr({}, ['request', 'query_params'], settings);
};

const { utm_source = '', utm_campaign = '', utm_medium = '', utm_term = '', mode = '', viewerOnly = false } = getQueryParams();

export const getUtmSourceString = () => {
    if (!utm_source && !utm_campaign && !utm_term) {
        return '';
    }

    return getTrimmedText([utm_source, utm_campaign, utm_term].join(';'), 100);
};

export const getSourceString = (source, isPhone) => {
    const utm = getUtmSourceString();
    return (
        (utm?.length ? `${utm}_` : '') +
        (path(['params', 'IS_WEBVIEW'], settings) ? 'webview' : isPhone ? 'touch' : 'web') +
        (source?.length ? `_${source}` : '')
    );
};

export const getInitialRequestId = (): string | undefined => {
    return path(['request', 'id'], settings);
};

export const getIsPwaMode = () => mode === 'standalone';

export const isViewContentOnly = viewerOnly;

export const isHiDPI = typeof window !== 'undefined' && window.devicePixelRatio >= 2;

export const isPromoQuotaInAndroid = utm_source === 'cloud_app' && utm_campaign === 'promo_quota' && utm_medium === 'android';
